var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1028_8264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#252525"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.5625H11.4375V3.9375C11.4375 3.82147 11.3914 3.71019 11.3094 3.62814C11.2273 3.54609 11.116 3.5 11 3.5C10.884 3.5 10.7727 3.54609 10.6906 3.62814C10.6086 3.71019 10.5625 3.82147 10.5625 3.9375V6.5625H7.9375C7.82147 6.5625 7.71019 6.60859 7.62814 6.69064C7.54609 6.77269 7.5 6.88397 7.5 7C7.5 7.11603 7.54609 7.22731 7.62814 7.30936C7.71019 7.39141 7.82147 7.4375 7.9375 7.4375H10.5625V10.0625C10.5625 10.1785 10.6086 10.2898 10.6906 10.3719C10.7727 10.4539 10.884 10.5 11 10.5C11.116 10.5 11.2273 10.4539 11.3094 10.3719C11.3914 10.2898 11.4375 10.1785 11.4375 10.0625V7.4375H14.0625C14.1785 7.4375 14.2898 7.39141 14.3719 7.30936C14.4539 7.22731 14.5 7.11603 14.5 7C14.5 6.88397 14.4539 6.77269 14.3719 6.69064C14.2898 6.60859 14.1785 6.5625 14.0625 6.5625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1028_8264",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1028_8264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1028_8264",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineAddIcon);
export default __webpack_public_path__ + "static/media/pipelineAddIcon.0fa9685ab84412d7c2d973647f9983ed.svg";
export { ForwardRef as ReactComponent };